import { createTheme} from "@mui/material/styles";
export function createLightTheme(dir){
  
  return createTheme({
  
   
  direction: dir,
 
  palette: {
    mode: "light",
    primary: {
    
      main:"#5ebec4"
 
    },
    secondary: {
      main: "#f92c85",
    
    },

    background: {
     //default:"#ededed"
      default: "#fdf5df"
    },
  },
  typography: {
    useNextVariants: true,
    fontFamily: "Gill Sans",
  },
 
});
}
export function createDarkTheme(dir){
  
  return createTheme({
  
   
  direction: dir,
  
   palette: {
     mode: "dark",
   primary: {
    
      main:"#5ebec4"
 
    },
    secondary: {
      main: "#f92c85",
    
    },
 
     background: {
       default:  "#000",
     },
   },
   typography: {
     useNextVariants: true,
     fontFamily: "Gill Sans",
   },
 });
}
// export default function getTheme(dir,themeMode) {

//     return createTheme({
  
   
//         direction: dir,
       
//         palette: {
//           mode: themeMode,
//           primary: {
//             main:"#205397" 
       
//           },
//           secondary: {
//             main: "#F96611",
//           },
    
//           background: {
//             default: themeMode == "light" ? "#f2f3f5" : "#000",
//           },
//         },
//         typography: {
//           useNextVariants: true,
//           fontFamily: "Gill Sans",
//         },
//       });

// }